<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="编辑租户"
    v-bind="$attrs"
    destroy-on-close
    :close-on-click-modal="false"
    width="1000px"
  >
    <div class="dialog-around h-60">
      <div class="h-full org-wrapper">
        <div class="org-create-wrapper">
          <rc-form ref="rcForm" v-bind="{ form, data: formData, formItem, showSearch: false }">
            <!-- <template #enterpriseStructure>
             <el-form-item :label="$t('orgManage.orgType')" prop="orgType">
               <el-select
                v-model="formData.orgType"
                :disabled="true"
                class="w100"
                :placeholder="$t('common.pleaseChoose')"
              >
                <el-option v-for="option in manageTypeList" :key="option.dictValue" :label="option.dictLabel" :value="option.dictValue"></el-option>
              </el-select>
             </el-form-item>
          </template> -->
          </rc-form>
        </div>
      </div>
    </div>

    <span slot="footer" class="text-right">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import api from "@/api/business";
import userApi from "@/api/user/user";
export default {
  name: "OrgEdit",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orgData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        labelPosition: "top",
        gutter: 20
      },
      formData: {
        enterpriseStructure: "COMMON",
        tenantName: "",
        socialCreditCode: "",
        effect: true,
        address: "",
        showName: "",
        adminMenuType: "ALL",
        tenantSource: "LOCAL"
      },
      formItem: [
        {
          component: "rc-input",
          label: "租户名称",
          placeholder: "请输入租户名称",
          prop: "tenantName",
          span: 12,
          rules: [
            {
              type: "string",
              required: true,
              pattern: /^\S{2,}$/,
              message: "不能输入空格，长度至少2位"
              // pattern: /^[a-zA-Z0-9\u4e00-\u9fa5]{2,}$/,
              // message: '不能输入空格，长度至少2位且不能含特殊字符'
            }
          ]
        },
        {
          component: "rc-input",
          label: "纳税识别号",
          prop: "socialCreditCode",
          placeholder: "请输入纳税识别号",
          rules: [
            {
              type: "string",
              min: 15,
              required: true,
              pattern: /^[a-zA-Z0-9\u4e00-\u9fa5]{15,}$/,
              message: "请输入正确的纳税识别号"
            }
          ],
          span: 12
        },
        {
          component: "rc-input",
          label: "地址",
          prop: "address",
          placeholder: "请输入地址",
          rules: [
            {
              type: "string",
              required: true,
              message: "请输入地址"
            }
          ],
          span: 24
        },
        {
          component: "rc-select",
          label: "租户类型",
          prop: "enterpriseStructure",
          disabled: true,
          span: 12,
          options: [
            {
              label: "普通企业",
              value: "COMMON"
            },
            {
              label: "集团型企业",
              value: "GROUP"
            }
          ],
          rules: [
            {
              type: "string",
              required: true,
              message: "请选择租户类型"
            }
          ]
        },
        {
          component: "rc-radio-group",
          label: "租户方式",
          prop: "tenantSource",
          span: 6,
          disabled: true,
          options: [
            {
              label: "平台租户",
              value: "PLATFORM"
            },
            {
              label: "本地租户",
              value: "LOCAL"
            }
          ],
          rules: [
            {
              type: "string",
              required: true,
              message: "请选择租户方式"
            }
          ]
        },
        {
          component: "rc-radio-group",
          label: "状态",
          prop: "effect",
          span: 6,
          options: [
            {
              label: "启用",
              value: true
            },
            {
              label: "禁用",
              value: false
            }
          ],
          rules: [
            {
              type: "boolean",
              required: true
            }
          ]
        },
        {
          component: "rc-addon-title",
          attribute: {
            label: "租户管理员",
            bar: true
          },
          span: 24,
          itemStyle: {
            marginBottom: "10px"
          }
        },
        {
          component: "rc-input",
          label: "用户名-姓名",
          prop: "showName",
          disabled: true,
          span: 12
        },
        {
          component: "rc-radio-group",
          label: "权限级别",
          prop: "adminMenuType",
          span: 12,
          options: [
            {
              label: "全量",
              value: "ALL"
            },
            {
              label: "部分",
              value: "ASSIGNED"
            }
          ],
          rules: [
            {
              type: "string",
              required: "ALL"
            }
          ]
        }
      ],
      enterpriseStructureList: [
        {
          label: "普通企业",
          value: "COMMON"
        },
        {
          label: "集团型企业",
          value: "GROUP"
        }
      ]
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.dialogVisible = val;
      }
    },
    dialogVisible(val) {
      this.$emit("update:visible", val);
    },
    orgData: {
      handler(val) {
        if (!val) {
          return;
        }

        // 处理传值
        this.formData = { ...val, showName: "" };
        // if (this.formData.enterpriseStructure === 'GROUP') {
        //   const itemObj = this.formItem.find(item => item.prop === 'enterpriseStructure');
        //   itemObj.disabled = true;
        // }
        const { adminId = "" } = val;

        if (adminId) {
          // 处理组合信息
          this.loadUserInfo(adminId);
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getFormFunction() {
      return this.$refs.rcForm.getComponentFunctionMap();
    },
    handleSubmit({ data }) {
      const { validate } = this.getFormFunction();
      validate(async valid => {
        if (valid) {
          try {
            const {
              tenantName,
              socialCreditCode,
              address,
              tenantId,
              adminId,
              enterpriseStructure,
              effect,
              deleteFlag = 0,
              adminMenuType,
              tenantSource
            } = this.formData;
            const params = {
              tenantName,
              socialCreditCode,
              address,
              tenantId,
              adminId,
              enterpriseStructure,
              effect,
              deleteFlag,
              tenantSource,
              adminMenuType
            };

            const { data: info } = await api.updateOrg(params);
            if (info) {
              this.$message.success("更新成功");
              this.dialogVisible = false;
              this.$emit("success");
            }
          } catch (error) {
            // this.$message.error('组织更新失败');
            throw new Error(error);
          }
        }
      });
    },
    async loadUserInfo(id) {
      try {
        const { data } = await userApi.getDetailsByIdNew(id);
        const { displayName, username } = data;
        this.formData.showName = `${username}-${displayName}`;
      } catch (error) {
        this.$message.error("获取管理员信息失败");
        throw new Error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.org-create-wrapper {
  padding: 0;
  height: 100%;

  ::v-deep .router {
    &:hover {
      color: white;
    }
  }
}
</style>
